export const getInverseOrder = (currentOrder?: 'asc' | 'desc') => {
  if (currentOrder === undefined || currentOrder === 'desc') return 'asc';
  return 'desc';
};